import { defineTour } from '@lopettia/simul';

/**
 * Sales executive — org-wide forecast and revenue cadence. Mirrors
 * docs/manuals/03-sales-executive.md.
 */
export const salesExecutiveTour = defineTour({
  name: 'Executive revenue cadence',
  description:
    'Org-wide forecast, revenue cadence, and the key dashboards a VP/CRO '
    + 'reviews each week.',
  steps: [
    {
      id: 'se-forecast',
      kind: 'info',
      target: '[data-tour-id="nav-analytics"]',
      prelude: { goto: '/analytics' },
      message:
        '**Executive view.** The org-wide forecast rolls every campaign '
        + 'and team into a single revenue projection.',
      advanceOn: 'manual',
      spotlight: true,
    },
    {
      id: 'se-cadence',
      kind: 'navigate',
      target: '[data-tour-id="nav-revenue-meeting"]',
      toUrl: '/revenue-meeting',
      message:
        'The **revenue cadence** view is your weekly meeting cockpit — '
        + 'commits, upside, and slipped deals at a glance.',
      advanceOn: 'navigate',
    },
    {
      id: 'se-dashboards',
      kind: 'navigate',
      target: '[data-tour-id="nav-dashboard"]',
      toUrl: '/dashboard',
      message: 'Anchor dashboards round out the cadence with KPI trend lines.',
      advanceOn: 'navigate',
    },
  ],
});

export default salesExecutiveTour;
